import { NetworkPointResource } from 'app/_resources/network-point.resource';
import { Growl } from 'angular/custom/services/growl.service';
import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'NetworkPointsPlatformSettingsCtrl',
            NetworkPointsPlatformSettingsCtrl
        );

    function NetworkPointsPlatformSettingsCtrl(
        $scope,
        $timeout,
        platformSettingsService,
        NetworkPoint: NetworkPointResource,
        growl: Growl
    ) {
        var vm = this;

        vm.uiShowAddNewFavorite = false;
        vm.uiNetworkPointsQueried = false;
        vm.uiFailedToQueryNetworkPoints = false;
        vm.favoriteNetworkPoints = [];
        vm.networkPointToDisfavor = null;
        vm.NEW_FAVORITE_NETWORK_POINT_PAGE =
            platformSettingsService.NEW_FAVORITE_NETWORK_POINT_PAGE;
        vm.QUICK_FILTER_PAGE = platformSettingsService.QUICK_FILTER_PAGE;
        vm.DIRECTION = platformSettingsService.DIRECTION;
        vm.disfavorNetworkPoint = disfavorNetworkPoint;

        NetworkPoint.favorites(
            { userFavoritesOnly: true },
            function (res) {
                vm.favoriteNetworkPoints = res;
                vm.uiNetworkPointsQueried = true;
            },
            function () {
                vm.uiNetworkPointsQueried = true;
                vm.uiFailedToQueryNetworkPoints = true;
            }
        );

        $scope.$on(
            platformSettingsService.BROADCAST.CANCEL_NEW_FAVORITE_NETWORK_POINT,
            function () {
                vm.uiShowAddNewFavorite = false;
            }
        );

        $scope.$on(
            platformSettingsService.BROADCAST.NEW_FAVORITE_NETWORK_POINT,
            function (e, res) {
                var i;
                for (i = 0; i < res.networkPoints.length; i++) {
                    vm.favoriteNetworkPoints.push(res.networkPoints[i]);
                }

                vm.uiShowAddNewFavorite = false;

                res.success
                    ? growl.show(
                          'You have new favoured network points.',
                          'success'
                      )
                    : growl.show(
                          'Favouring new network points failed.',
                          'danger'
                      );
            }
        );

        function disfavorNetworkPoint() {
            NetworkPoint.disfavor(
                { id: vm.networkPointToDisfavor.id },
                function () {
                    vm.favoriteNetworkPoints.splice(
                        vm.favoriteNetworkPoints.indexOf(
                            vm.networkPointToDisfavor
                        ),
                        1
                    );
                    growl.show(
                        'You have disfavoured this network point.',
                        'success'
                    );
                },
                function (err: ng.IHttpPromiseCallbackArg<RestError>) {
                    const errorCode =
                        err && err.data && err.data.errorCode
                            ? err.data.errorCode
                            : '';
                    growl.show(
                        'Could not disfavour this network point, please try again later.',
                        'danger',
                        { errorCode }
                    );
                }
            );
        }
    }
})();
